import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Button } from "@chakra-ui/react";

const InfoModal = ({ title, message, isOpen, onClose, isError, callback=null }) => {

    const handleClose = () => {
        if (callback) {
            callback();
        }
        onClose();
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader color={isError ? "red" : "black"} fontWeight={"bold"}>
                    {title}
                </ModalHeader>
                <ModalCloseButton color={"black"}/>
                <ModalBody>
                    <div>
                        {message}
                    </div>
                    <div className="d-flex justify-content-between">
                        <Button colorScheme={isError ? "red" : "blue"} mt={3} mb={3} ml={"auto"} onClick={onClose}>
                            Aceptar
                        </Button>
                    </div>
                </ModalBody>
                <ModalCloseButton />
            </ModalContent>
        </Modal>
    )
}

export default InfoModal;
